import React, { useState } from "react";
import { 
  Card, 
  Row, 
  Col, 
  Form, 
  Button, 
  Spinner, 
  Alert 
} from "react-bootstrap";
import ViewService from "../../services/view/ViewService";
import Navigation from "./navigation";
import Logo2 from "../../assets/images/BPPMHKP.png";

const ValSmkhp = () => {
  const [noHcMutu, setNoHcMutu] = useState("");
  const [npwp, setNpwp] = useState("");
  const [traderInfo, setTraderInfo] = useState(null);
  const [resultData, setResultData] = useState(null);
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);

  const handleCheck = async (e) => {
    e.preventDefault();
    if (!noHcMutu || !npwp) {
      setError("Silahkan isi semua kolom input terlebih dahulu.");
      return;
    }

    setIsLoading(true);
    setError(null);
    setHasSearched(true);
    setResultData(null);
    setTraderInfo(null);

    try {
      const service = new ViewService();
      const response = await service.getValSmkhpbyNoHcMutu(noHcMutu, npwp);
      
      if (response && response.data && response.data.status === "success") {
        const traderData = response.data.data;
        const detailHc = traderData?.list_ppk?.[0]?.detail_hc;
        
        if (detailHc) {
          setTraderInfo(traderData); 
          setResultData(detailHc);   
        } else {
          setResultData(null);
          setTraderInfo(null);
        }
      } else {
        setResultData(null);
        setTraderInfo(null);
      }
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || "Gagal memvalidasi data. Silahkan coba lagi.");
    } finally {
      setIsLoading(false);
    }
  };

  const formatNPWP = (value) => {
    const cleaned = value.replace(/\D/g, "");
    const truncated = cleaned.slice(0, 16);

    // format 000.000.000.0-000.000
    const match = truncated.match(/^(\d{3})(\d{0,3})(\d{0,3})(\d{0,1})(\d{0,3})(\d{0,3})$/);

    if (match) {
      let formatted = match[1];
      if (match[2]) formatted += `.${match[2]}`;
      if (match[3]) formatted += `.${match[3]}`;
      if (match[4]) formatted += `.${match[4]}`;
      if (match[5]) formatted += `-${match[5]}`;
      if (match[6]) formatted += `.${match[6]}`;
      return formatted;
    }

    return truncated;
  };

   
    const KodeStatus = { 
      "00": 'Dalam Antrian', 
      "01": 'Dalam Proses', 
      "02": 'Data SMKHP Telah Dikirim Ke Karantina' 
    };

    const MapKolomWaktu = {
      "00": "waktu_antrian",
      "01": "waktu_proses",
      "02": "waktu_response"
    };

    const dataAntrian = resultData?.antrian_smkhp_ki;
    const statusSaatIni = dataAntrian?.kode_status; // "02"
    const fieldWaktuYgDigunakan = MapKolomWaktu[statusSaatIni];
    const dataWaktu = dataAntrian?.[fieldWaktuYgDigunakan]; 
    const cleanDateString = dataWaktu ? dataWaktu.replace('Z', '') : null;

  return (
    <>
    <div className="d-flex flex-column min-vh-100">
      {/* NAVBAR */}
     <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm py-2">
        <div className="container">
          <a className="navbar-brand" 
            //  href="#header" 
             style={{ display: 'flex', alignItems: 'center', fontWeight: 'bold', fontSize: '1.6rem' }}
          >
            <img 
              src={Logo2}
              className="img-responsive" 
              style={{ width: '60px', marginRight: '12px' }}
              alt="Logo"
            />
            <span className="text-dark">Badan Mutu KKP</span>
          </a>
          <span className="navbar-text fw-semibold text-secondary d-none d-sm-block">
            SIAPMUTU
          </span>
        </div>
      </nav>  

      <main 
      className="container-fluid  flex-grow-1" 
      style={{ 
        background: "linear-gradient(135deg, #e0f2fe 0%, #f1f5f9 100%)", 
        paddingTop: "70px" 
      }}
    >
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
        
            <Card className="shadow border-0 mb-3 rounded-3 overflow-hidden">
              <Card.Header className="bg-white border-bottom py-2">
                <Card.Title as="h4" className="text-primary fw-bold mb-0">
                  Penelusuran SMKHP
                </Card.Title>
                <small className="text-muted">Masukkan nomor SMKHP dan NPWP untuk melakukan pengecekan</small>
              </Card.Header>
              <Card.Body className="p-4 bg-white">
                <Form onSubmit={handleCheck}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-1">
                        <Form.Label className="fw-semibold text-secondary">Nomor SMKHP</Form.Label>
                        <Form.Control
                          size="lg"
                          type="text"
                          placeholder="Masukan No Referensi SMKHP"
                          value={noHcMutu}
                          onChange={(e) => setNoHcMutu(e.target.value)}
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label className="fw-semibold text-secondary">NPWP</Form.Label>
                        <Form.Control
                          size="lg"
                          type="text"
                          placeholder="Masukan NPWP (16 digit angka)"
                          value={npwp}
                          onChange={(e) => setNpwp(formatNPWP(e.target.value))}
                          title="Format NPWP harus lengkap sesuai contoh (16 digit angka)"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  
                  {/* {error && <Alert variant="danger" className="mt-2 py-2 fw-semibold">{error}</Alert>} */}

                  <div className="d-grid gap-1 d-md-flex justify-content-md-end mt-1">
                    <Button 
                      variant="primary" 
                      size="lg" 
                      type="submit" 
                      disabled={isLoading}
                      className="px-4 fw-bold shadow-sm"
                    >
                      {isLoading ? (
                        <>
                          <Spinner animation="border" size="sm" className="me-2" />
                          Memproses...
                        </>
                      ) : (
                        "Periksa Data"
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>

            {/* HASIL PENCARIAN */}
            {hasSearched && !isLoading && (
              resultData ? (
                <Card className="shadow border-0 border-start border-success border-4 rounded-3 overflow-hidden">
                  <Card.Header className="bg-white border-bottom py-3 d-flex justify-content-between align-items-center">
                    <h5 className="fw-bold mb-0 text-success">✓ Data SMKHP Valid / Ditemukan</h5>
                    <span className="badge bg-success px-3 py-2 rounded-pill">VALID</span>
                  </Card.Header>
                  <Card.Body className="p-4 bg-white">
                    <Row className="g-3">
                      
                      <Col sm={4} className="text-muted fw-semibold">NPWP Perusahaan</Col>
                      <Col sm={8} className="fw-bold text-dark">{traderInfo?.NPWP || "-"}</Col>
                      <hr className="my-2 opacity-25" />

                      {/* <Col sm={4} className="text-muted fw-semibold">Nama Perusahaan</Col>
                      <Col sm={8} className="fw-bold text-primary">{traderInfo?.NAMA || "-"}</Col>
                      <hr className="my-2 opacity-25" /> */}

                      <Col sm={4} className="text-muted fw-semibold">Nomor SMKHP</Col>
                      <Col sm={8} className="fw-bold text-dark">{resultData.no_hc_mutu}</Col>
                      <hr className="my-2 opacity-25" />

                      <Col sm={4} className="text-muted fw-semibold">Tanggal Diterbitkan</Col>
                      <Col sm={8} className="text-dark">
                        {resultData.tgl_hc 
                          ? new Date(resultData.tgl_hc).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' })
                          : "-"
                        }
                      </Col>
                      <hr className="my-2 opacity-25" />

                      <Col sm={4} className="text-muted fw-semibold">Diterbitkan Oleh</Col>
                      <Col sm={8} className="fw-bold text-dark">{resultData.upt?.NM_PENDEK_BARU}</Col>
                      <hr className="my-2 opacity-25" />

                      {/* <Col sm={4} className="text-muted fw-semibold">Pelabuhan Asal</Col>
                      <Col sm={8} className="text-dark fw-semibold">{resultData.pel_asal || "-"}</Col>
                      <hr className="my-2 opacity-25" /> */}

                      <Col sm={4} className="text-muted fw-semibold">Negara Tujuan</Col>
                      <Col sm={8} className="text-dark fw-semibold">{resultData.negara?.URAIAN_NEGARA || "-"}</Col>
                      <hr className="my-2 opacity-25" />

                      {/* <Col sm={4} className="text-muted fw-semibold">Deskripsi Produk</Col>
                      <Col sm={8} className="text-dark" style={{ textAlign: 'justify', fontSize: '0.95rem' }}>
                        {resultData.deskripsi_produk || "-"}
                      </Col> */}
                      
                      <hr className="my-3 opacity-50" />
                      <Col sm={4} className="text-muted fw-semibold d-flex align-items-center">
                        <span>Status Karantina</span>
                      </Col>
                      <Col sm={8}> 
                      {dataWaktu ? ( 
                        <div className="p-3 rounded bg-light border"> 
                          <div className="d-flex align-items-center mb-1"> 
                            <span className="badge bg-info me-2 text-dark">
                              {KodeStatus[statusSaatIni] || statusSaatIni}
                            </span> 
                            {/* <small className="text-muted"> 
                              {new Date(dataWaktu).toLocaleString('id-ID', { 
                                day: 'numeric', 
                                month: 'short', 
                                year: 'numeric', 
                                hour: '2-digit', 
                                minute: '2-digit', 
                                second: '2-digit' 
                              })} WIB 
                            </small>  */}
                          </div> 
                          <div className="text-secondary font-monospace" style={{ fontSize: "0.85rem", maxHeight: "80px", overflowY: "auto" }}> 
                            <small className="text-muted"> 
                                {cleanDateString ? (
                                  new Date(cleanDateString).toLocaleString('id-ID', { 
                                    day: 'numeric', 
                                    month: 'short', 
                                    year: 'numeric', 
                                    hour: '2-digit', 
                                    minute: '2-digit', 
                                    second: '2-digit' 
                                  })
                                ) : "-"} WIB 
                              </small>
                            {/* <strong>Response:</strong> {dataAntrian?.response_message || "-"}  */}
                          </div> 
                        </div> 
                      ) : ( 
                        <span className="text-warning fw-semibold">⚠️ Belum ada riwayat atau data waktu tidak ditemukan.</span> 
                      )} 
                    </Col>


                    </Row>
                  </Card.Body>
                </Card>
              ) : (
                <Card className="shadow border-0 border-start border-danger border-4 text-center py-5 rounded-3">
                  <Card.Body>
                    <div className="text-danger mb-3" style={{ fontSize: "2.5rem" }}>⚠️</div>
                    <h5 className="fw-bold text-danger">Data Tidak Ditemukan</h5>
                    <p className="text-muted mb-0 mx-auto" style={{ maxWidth: "450px" }}>
                      Nomor SMKHP atau NPWP yang Anda masukkan tidak terdaftar di sistem. Pastikan kembali input Anda sudah benar.
                    </p>
                  </Card.Body>
                </Card>
              )
            )}

          </Col>
        </Row>
      </main>
        <footer className="bg-white  mt-auto border-top border-light shadow-sm">
          <div className="container text-center">
            <p className="mb-0 small text-muted">
              © Kementerian Kelautan dan Perikanan Republik Indonesia | {" "}
              <a href="http://kkp.go.id/unit-kerja/bppmhkp.html" rel="noopener noreferrer" target="_blank" className="text-decoration-none fw-semibold">
                Badan Mutu KKP
              </a>
            </p>
          </div>
        </footer>
      </div>
     
    </>
  );
};

export default ValSmkhp;